<template>
  <el-card shadow="always">
    <div slot="header" class="clearfix">
      <span>Dados do objeto</span>
    </div>
    <div>
      <el-form ref="form" :model="ruleForm" :label-position="labelPosition" label-width="180px">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="18" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('peso') + '(g)'" prop="weight" :required="true">
              <el-input type="number" min="1" step="1" pattern="[0-9]" v-model="ruleForm.weight"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24">
            <el-form-item class="no-margin-bottom" :label="$t('conteudo')" prop="contents" :required="true">
              <el-input v-model="ruleForm.contents"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('embalagem')" prop="package">
              <PackingList ref="package" v-model="ruleForm.package" v-on:selected="selected"
                :current="ruleForm.package" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24">
            <el-form-item class="no-margin-bottom" :label="$t('largura-cm')" prop="length">
              <el-slider @change="calcTotal()" v-model="ruleForm.width" show-input>
              </el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24">
            <el-form-item class="no-margin-bottom" :label="$t('comprimento-cm')" prop="width">
              <el-slider @change="calcTotal()" v-model="ruleForm.length" show-input>
              </el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24">
            <el-form-item class="no-margin-bottom" :label="$t('altura-cm')" prop="height">
              <el-slider @change="calcTotal()" v-model="ruleForm.height" show-input>
              </el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24">
            <el-form-item class="no-margin-bottom" :label="$t('valor-declarado')" prop="value">
              <el-slider @change="calcTotal()" v-model="ruleForm.value" :step="0.1" show-input>
              </el-slider>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom clearfix right" style="margin-bottom: 10px">
      <el-button type="primary" @click="confirm">Adicionar ao itenerário</el-button>
    </div>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import PackingList from "@/xpost/views/register/packing/PackingList";

export default {
  name: "MotoboyObject",
  props: ["state", "labelPosition"],
  components: { PackingList },
  computed: {
    packagename() {
      const vm = this;
      if (vm.$refs.package && vm.ruleForm.package) {
        const record = vm.$refs.package.find(vm.ruleForm.package);
        if (record) {
          return record.name;
        }
      }
      return vm.ruleForm.package;
    },
  },
  methods: {
    confirm() {
      const vm = this;
      vm.$emit("add");
    },
    warning(a, b) {
      const vm = this;
      if (vm.ruleForm[a]) vm.ruleForm[b] = false;
    },
    selected() {
      const vm = this;
      if (vm.$refs.package && vm.ruleForm.package) {
        const record = vm.$refs.package.find(vm.ruleForm.package);
        if (record) {
          vm.measure.width = +record.width;
          vm.measure.height = +record.height;
          vm.measure.length = +record.length;
        }
      }
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    clear() {
      const vm = this;
      vm.ruleForm.contents = "";
      vm.ruleForm.weight = 0;
      vm.ruleForm.package = "";
    },
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        weight: 0,
        value: 0,
        height: 0,
        length: 0,
        width: 0,
        package: "",
        contents: "",
      },
    };
  },
};
</script>
